import { render, staticRenderFns } from "./TableFull.vue?vue&type=template&id=aba060e8"
import script from "./TableFull.vue?vue&type=script&lang=js"
export * from "./TableFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports